import { useEffect } from 'react'
import * as React from 'react'
import { useRouter } from 'next/router'
import useIsWebview from '@app.modules/hooks/useIsWebview'
import { getWebviewHref } from '@app.modules/util'

const useTagEffect = (ref: React.RefObject<HTMLDivElement>): void => {
  const router = useRouter()
  const isWebview = useIsWebview()
  useEffect(() => {
    const tags = ref.current?.getElementsByClassName('ql-hashtag')
    if (!tags) return

    const onTagClick = (tagElementEvent) => {
      const targetSpan = tagElementEvent.target as HTMLSpanElement
      const tagKeyword = encodeURIComponent(targetSpan.innerText || '').replace(
        /%EF%BB%BF/g,
        '',
      )
      const query = [`q=${tagKeyword}`]

      if (isWebview) {
        const backHref = router.query.back ? router.query.back : router.asPath
        const backKeyword = encodeURIComponent(`${backHref || ''}`).replace(
          /%EF%BB%BF/g,
          '',
        )

        query.push(`back=${backKeyword}`)
      }

      const url = getWebviewHref(
        `/channel/search?${query.join('&')}`,
        isWebview,
      )

      router.push(url)
    }

    for (let i = 0; i < tags.length; i++) {
      tags[i].addEventListener('click', onTagClick)
    }

    return () => {
      for (let i = 0; i < tags.length; i++) {
        tags[i].removeEventListener('click', onTagClick)
      }
    }
  }, [router, ref, isWebview, router.query.back, router.asPath])
}

export default useTagEffect
